module.exports = __webpack_public_path__ + "img/logo_jawapos.9ecc85d7.png";